import { useEffect, useState } from "react";
import { getReceiptTypeList } from "utils/api/lookupApi";
import { OptionRenderType } from "controls/global/stewart-checkbox/StewartAutocompleteWithCheckboxes";

// Accounting Record Type options for the AR grid, sourced from
// /lookup/GetPIList/ReceiptType. Label = ReceiptTypeName, value = ReceiptTypeCode.
export function useReceiptTypeOptions(): OptionRenderType[] {
  const [options, setOptions] = useState<OptionRenderType[]>([]);
  useEffect(() => {
    let mounted = true;
    getReceiptTypeList().then((rows) => {
      if (!mounted) return;
      setOptions(
        rows.map((r) => ({
          label: r.ReceiptTypeName,
          value: r.ReceiptTypeCode,
        }))
      );
    });
    return () => {
      mounted = false;
    };
  }, []);
  return options;
}

export default useReceiptTypeOptions;
